import api from "./api";
import { GenericAuditLogPayload } from "@/types";

const { pimcoreServiceAPI, pimcoreGuestServiceAPI } = api;

const GET_GENERIC_AUDIT_TRAIL_PATH = "/audittrail/generic";
const GET_NDA_TEMPLATE_CONTENT_PATH = `/asset/documentType/NDA_TEMPLATE/content`;

const CHECK_PAGE_LOCK_PATH = "/lock/page";

const PimcoreService = {
  getGenericAuditTrail: async (payload: GenericAuditLogPayload) => {
    try {
      const url = `${GET_GENERIC_AUDIT_TRAIL_PATH}`;
      const resp = await pimcoreServiceAPI.post(url,payload);
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  getNDATemplate: async (): Promise<Blob> => {
    try {
      const resp = await pimcoreServiceAPI.get(GET_NDA_TEMPLATE_CONTENT_PATH, { responseType: 'blob' });
      return resp.data;
    } catch (error) {
      throw error;
    }
  },
  getGuestNDATemplate: async (): Promise<Blob> => {
    try {
      const resp = await pimcoreGuestServiceAPI.get(GET_NDA_TEMPLATE_CONTENT_PATH, { responseType: 'blob' });
      return resp.data;
    } catch (error) {
      throw error;
    }
  },

  checkPageLock: async (pageId: string, objectId: string | number) => {
    try {
      const url = `${CHECK_PAGE_LOCK_PATH}/${pageId}/${objectId}`;
      const resp = await pimcoreServiceAPI.get(url);
      return resp;
    } catch (error) {
      throw error;
    }
  },

  deletePageLock: async (pageId: string, objectId: string | number) => {
    try {
      const url = `${CHECK_PAGE_LOCK_PATH}/${pageId}/${objectId}`;
      const resp = await pimcoreServiceAPI.delete(url);
      return resp;
    } catch (error) {
      throw error;
    }
  },

  // NEW: Synchronous delete for browser unload scenarios
  deletePageLockSync: (pageId: string, objectId: string | number) => {
    const url = `${CHECK_PAGE_LOCK_PATH}/${pageId}/${objectId}`;
    const { keepaliveAPI } = api;
    return keepaliveAPI.delete(pimcoreServiceAPI, url);
  },

  
};

export default PimcoreService;
